const ACCESS_TOKEN_KEY = 'artrouting_access_token';
const REFRESH_TOKEN_KEY = 'artrouting_refresh_token';

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setRefreshToken(token: string): void {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

interface JWTPayload {
  sub?: string;
  email?: string;
  displayName?: string;
  role?: string;
  permissions?: string[];
  exp?: number;
  iat?: number;
  [key: string]: unknown;
}

export function parseJWT(token: string): JWTPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded) as JWTPayload;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  const payload = parseJWT(token);
  if (!payload?.exp) return true;
  // Add 30-second buffer
  return Date.now() >= (payload.exp * 1000) - 30000;
}

// ── Impersonation Helpers ───────────────────────────────────────

const ORIGINAL_ACCESS_KEY = 'artrouting_original_access_token';
const ORIGINAL_REFRESH_KEY = 'artrouting_original_refresh_token';

export function saveOriginalTokens(): void {
  const access = getAccessToken();
  const refresh = getRefreshToken();
  if (access) localStorage.setItem(ORIGINAL_ACCESS_KEY, access);
  if (refresh) localStorage.setItem(ORIGINAL_REFRESH_KEY, refresh);
}

export function getOriginalTokens(): { accessToken: string | null; refreshToken: string | null } {
  return {
    accessToken: localStorage.getItem(ORIGINAL_ACCESS_KEY),
    refreshToken: localStorage.getItem(ORIGINAL_REFRESH_KEY),
  };
}

export function clearOriginalTokens(): void {
  localStorage.removeItem(ORIGINAL_ACCESS_KEY);
  localStorage.removeItem(ORIGINAL_REFRESH_KEY);
}

export function isImpersonating(): boolean {
  return localStorage.getItem(ORIGINAL_ACCESS_KEY) !== null;
}
